// src/hooks/useDirtyGuard.js
import { useEffect, useRef } from 'react';

export default function useDirtyGuard() {
  const dirtyRef = useRef(false);
  const askedRef = useRef(false);

  // Avviso nativo del browser su ricarica/chiusura scheda
  useEffect(() => {
    const handler = (e) => {
      if (!dirtyRef.current) return;
      e.preventDefault();
      e.returnValue = ''; // necessario per Chrome
    };
    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, []);

  // Sincrono — nessuna race condition con redirect
  const markDirty = () => { dirtyRef.current = true; };
  const resetDirty = () => { dirtyRef.current = false; };

  // Conferma custom (per pulsante "Annulla"/chiudi)
  const confirmIfDirty = async () => {
    if (!dirtyRef.current) return true;
    if (askedRef.current) return false;
    askedRef.current = true;
    const ok = window.confirm('Hai modifiche non salvate. Uscire senza salvare?');
    askedRef.current = false;
    if (ok) dirtyRef.current = false;
    return ok;
  };

  return { dirty: dirtyRef.current, markDirty, resetDirty, confirmIfDirty };
}
